export default __webpack_public_path__ + "static/media/success6.png";